import Column from 'Components/Base/Column'
import Icon from 'Components/Base/Icon'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import React, { useEffect, useState } from 'react'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import { Paragraph, SectionInfo } from 'types/Challenge'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function FLStep4({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {
    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      ),
    )
    setStepParagraphs(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      )?.paragraphs,
    )
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])

  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px', width: isMobile ? '100%' : '150%' }}>
          <Typography variant="h1">{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 7)?.paragraph ?? ''}</Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 20px' : '20px 0px' }}>
          <Icon name="check-circle" size="2x" styles={{ marginRight: 10 }} color="#7A9A01" />
          <Typography variant="h1" color="#7A9A01">
            {sectionInfo?.titles.find((title) => title.titleId === 4)?.titleText ?? ''}
          </Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 8)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 9)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 10)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 11)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 12)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 70px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 13)?.paragraph ?? ''}
          </li>
        </Row>
      </Column>
      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px -10px' : '90px 0px 20px' }}>
          <Icon name="circleX" size="2x" styles={{ marginRight: 10 }} color="#E80036" />
          <Typography variant="h1" color="#E80036">
            {sectionInfo?.titles.find((title) => title.titleId === 5)?.titleText ?? ''}
          </Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 15)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 16)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 17)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 18)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 19)?.paragraph ?? ''}
          </li>
        </Row>
        <Row styles={{ margin: isMobile ? '20px 40px' : '10px 70px' }}>
          <li style={{ fontFamily: 'Raleway', textIndent: '-1.5em', fontSize: 20 }}>
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 20)?.paragraph ?? ''}
          </li>
        </Row>
      </Column>
    </ResponsiveContainer>
  )
}
